/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeePayPeriodSummary } from './EmployeePayPeriodSummary';
import {
    EmployeePayPeriodSummaryFromJSON,
    EmployeePayPeriodSummaryFromJSONTyped,
    EmployeePayPeriodSummaryToJSON,
    EmployeePayPeriodSummaryToJSONTyped,
} from './EmployeePayPeriodSummary';

/**
 * 
 * @export
 * @interface ListEmployeePayPeriodSummariesResponse
 */
export interface ListEmployeePayPeriodSummariesResponse {
    /**
     * 
     * @type {Array<EmployeePayPeriodSummary>}
     * @memberof ListEmployeePayPeriodSummariesResponse
     */
    data: Array<EmployeePayPeriodSummary>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeePayPeriodSummariesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeePayPeriodSummariesResponse interface.
 */
export function instanceOfListEmployeePayPeriodSummariesResponse(value: object): value is ListEmployeePayPeriodSummariesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeePayPeriodSummariesResponseFromJSON(json: any): ListEmployeePayPeriodSummariesResponse {
    return ListEmployeePayPeriodSummariesResponseFromJSONTyped(json, false);
}

export function ListEmployeePayPeriodSummariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeePayPeriodSummariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeePayPeriodSummaryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeePayPeriodSummariesResponseToJSON(json: any): ListEmployeePayPeriodSummariesResponse {
      return ListEmployeePayPeriodSummariesResponseToJSONTyped(json, false);
  }

  export function ListEmployeePayPeriodSummariesResponseToJSONTyped(value?: ListEmployeePayPeriodSummariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeePayPeriodSummaryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

